import { HeaderBanner } from '@husslehq/api-client-ts';
import Cookies from 'js-cookie';

const cookiePrefix = 'promotion_dismissed';

export const promotionIsDismissed = (promotion: HeaderBanner | undefined): boolean => {
  if (typeof promotion === 'undefined') return false;

  return Cookies.get(`${cookiePrefix}_${promotion.code}`) !== undefined;
};

export const promotionMarkAsDismissed = ({ code }: HeaderBanner): void => {
  Cookies.set(`${cookiePrefix}_${code}`, '1');
};
